<template>
<div>
  <div>
    <loader v-model=status.loading></loader>
    <arksnackbar v-model="status"></arksnackbar>
    <confirm ref="confirm"></confirm>
  </div>
  <div>
    <v-layout row justify-center>
      <customdialog v-model="dialog" :maxWidth="options.width" title="Sicil Bilgileri" :cardtextstyle="'height: 420px;'">
        <template slot="header">
          <v-card-title>
            <v-text-field readonly label="Sicil No" v-model="musteriPersonelValue.SicilNo" append-outer-icon="clear" @click:append-outer="temizle()"></v-text-field>
            <v-btn margin="6px 8px" icon color="primary" @click.stop="profilAra()">
              <v-icon>search</v-icon>
            </v-btn>
          </v-card-title>
        </template>
        
        
        <template v-if ="musteriPersonelValue.KapatAc">
          
          <p style="color:red">Dikkat !!! Bu Sicil No Kapatılmıştır.</p>
        </template>
        
        <table>
          <tr>
          <th></th>   
          <th></th>
        </tr>
          
       
        
        <tr>
          <th>Şirket Adı :</th>   <td>{{ musteriPersonelValue.SirketAdi }}</td>
        </tr>
        <tr>
          <th>MasrafYeri :</th>  <td>{{ musteriPersonelValue.MasrafYeri }}</td>
        </tr>
        
        <tr>
          <th>Adi :</th>  <td>{{ musteriPersonelValue.Adi }}</td>
        </tr>
        <tr>
          <th>Soyadi :</th>  <td>{{ musteriPersonelValue.Soyadi }}</td>
        </tr>
        
        <tr>
          <th>CalismaYeri :</th>  <td>{{ musteriPersonelValue.CalismaYeri }}</td>
        </tr>
      
        <tr>
          <th>Bolum :</th>  <td>{{ musteriPersonelValue.Bolum }}</td>
        </tr>
      
        <tr>
          <th>IcSeyahat :</th>  <td>{{ musteriPersonelValue.IcSeyahat }}</td>
        </tr>
        <tr>
          <th>DisSeyahat :</th>  <td>{{ musteriPersonelValue.DisSeyahat }}</td>
        </tr>
        <tr>
          <th>IsAlani :</th>  <td>{{ musteriPersonelValue.IsAlani }}</td>
        </tr>
        <tr>
          <th>Siparis :</th>  <td>{{ musteriPersonelValue.Siparis }}</td>
        </tr>
        <tr>
          <th>Email :</th>  <td>{{ musteriPersonelValue.Email }}</td>
        </tr>
        <tr>
          <th>Tel :</th>  <td>{{ musteriPersonelValue.Tel }}</td>
        </tr>
        <tr>
          <th>CariKod :</th>  <td>{{ musteriPersonelValue.Cari.Kod }}</td>
        </tr>
 
        </table>

        <template slot="btn">
          <v-btn color="primary" flat @click.native="yes()">{{ $t('save_button') }} </v-btn>
        </template>

      </customdialog>
    </v-layout>
  </div>

  <!-- Arama Dialog -->

  <customdialog v-model="dialogAra" :maxWidth="options.width" title="Profil Arama" :cardtextstyle="'height: 420px;'">
    <template slot="header">
      <v-card-title>
        <v-text-field ref="aramatext" solo outline hide-details v-model="aranacak" label="Ad" append-icon="search" @click:append-outer="yenile();" v-on:keyup.13="yenile();"></v-text-field>
        <v-text-field ref="aramatext2" solo outline hide-details v-model="aranacak2" label="Soyad" append-outer-icon="refresh" append-icon="search" @click:append-outer="yenile();" v-on:keyup.13="yenile();"></v-text-field>
      </v-card-title>
    </template>

    <!-- Begin Data Table ************************************************************************************-->
    <div class="flex md12">
      <v-data-table :headers="tableheaders" :items="tableitems" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr @click="yesAraId(props.item.ID)">
            <td v-for="tableheader in tableheaders" :key="tableheader.ID">
              {{props.item[tableheader.value]}}
            </td>
          </tr>
        </template>

      </v-data-table>
    </div>
    <!-- End Data Table *************************************************************************************** -->

    <template slot="btn">
      <v-btn color="primary" flat @click.native="yesAra()"> {{$t('save_button') }} </v-btn>
    </template>

  </customdialog>

</div>
</template>

<script>

import confirm from "@/components/app/coper/comp/confirm.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";

import tool from "../tools";

export default {
  data() {
    return {
      ilk: false,
      dialog: false,
      dialogAra: false,
      aramakriter: null,
      status: tool.NewSatatus(),
      tableheaders: [{
          text: 'ID',
          value: 'ID'
        },
        {
          text: 'Adi',
          value: 'Adi'
        },

        {
          text: 'Soyadi',
          value: 'Soyadi'
        },

        {
          text: 'SicilNo',
          value: 'SicilNo'
        },

        {
          text: 'MasrafYeri',
          value: 'MasrafYeri'
        },

      ],
      tableitems: [],

      aranacak: null,
      aranacak2: null,
      

      resolve: null,
      reject: null,

      resolveAra: null,
      rejectAra: null,

      profilId: 0,
      sablonTipList: [],
      sablonTipId: null,
      profilSablonValue: [],
      musteriPersonelValue: {Cari:{Kod:''}},

      valid: true,

      options: {
        color: "primary",
        width: 800,
        message: null
      }
    };
  },
  components: {
    confirm,
    arksnackbar,
    loader,
    customdialog,
  },

  methods: {
    open(profilId, options) {
      this.ilk = true;
      this.dialog = true;
      this.profilId = profilId;
      //this.profilId = 769;

      this.getMusteriPersonel(this.profilId, this.sablonTipId);

      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    openAra() {

      this.dialogAra = true;
      return new Promise((resolveAra, rejectAra) => {
        this.resolveAra = resolveAra;
        this.rejectAra = rejectAra;
      });
    },

    yes() {

        //this.profilKaydet();
        this.resolve({
        id: this.profilId,
        ok: true,
      });
      this.dialog = false;
      
    },
    cancel() {
      if (this.dialogAra == false) {
        this.resolve({
          ok: false
        });
        this.dialog = false;
      }
    },

    yesAra() {
      this.resolveAra({
        ok: true,
        profilId: this.tableitems[0].Id,
      });
      this.dialogAra = false;
    },
    yesAraId(id) {
      this.resolveAra({
        ok: true,
        profilId: id,
      });
      this.dialogAra = false;
    },

    cancelAra() {
      this.resolveAra({
        ok: false
      });
      this.dialogAra = false;
    },



    getMusteriPersonel: getMusteriPersonel,
    sablonChange: sablonChange,
    profilAra: profilAra,
    yenile: yenile,
    temizle:temizle

  }
};

function temizle(){
  this.profilId= 0;
  this.musteriPersonelValue= {Cari:{Kod:''}};

}

function yenile() {

  var prm = {
    Adi: this.aranacak,
    Soyadi: this.aranacak2,
    
  }


  this.status.loading = true;
  tool.api_post(this, "Extra/CustomerPersonnelListCoper", prm).then(
    response => {
      //this.tableheaders = ["ID","Adi"];


      this.tableitems = response.body;

      this.status.loading = false;
      //this.status.show = true;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function profilAra() {

  this.openAra().then(profildialogAra => {
    if (profildialogAra.ok) {
      this.profilId = profildialogAra.profilId;
      this.getMusteriPersonel(this.profilId, this.sablonTipId);

    }

  });
}

function sablonChange() {

  


  this.tableitems = [];

  if (this.ilk == true) {
    this.ilk = false;
  } else {
    this.profilId = 0;
  }

  this.getMusteriPersonel(this.profilId, this.sablonTipId);
}


function getMusteriPersonel(profilID, sablonID) {
  if(profilID>0)
  {
    this.status.loading = true;
    tool.api_post(this, "Extra/CustomerPersonnelListCoper", {
      ID: profilID
    }).then(
      response => {
        this.musteriPersonelValue = response.body[0]
        this.status.loading = false;
      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  }else{
    this.musteriPersonelValue={Cari:{Kod:''}};
  }
}


</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 2px;
  border-bottom: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
.ustlogo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 100px;
}

.parametread {
  text-align: right;
}

.parametredeger {
  text-align: left;
}

.baslik {
  text-align: center;
  background-color: #b0e9f4;
  font-size: 18pt;
  color: #362edd;
  font-weight: bold;
}

.grupbaslik {
  text-align: left;
  color: #c60303;
}

.thInt,
.thStr,
.thDate {
  background-color: #b0e9f4;
}

.thCur {
  text-align: right;
  background-color: #b0e9f4;
}

.thlInt,
.thlStr,
.thlDate {
}

.thlCur {
  text-align: right;
}

.thd {
  text-align: right;
  color: #362edd;
}

.thdCur {
  text-align: right;
  color: #362edd;
}

.thg {
  text-align: right;
  color: #c60303;
}

.thgCur {
  text-align: right;
  color: #c60303;
}
</style>
